
    var riot = require('riot')
    import { Breadcrumbs } from './gb-breadcrumbs';
riot.tag2('gb-breadcrumbs', '<yield> <div class="gb-breadcrumbs"> <gb-query-crumb if="{!$breadcrumbs.hideQuery}"></gb-query-crumb> <gb-list if="{!$breadcrumbs.hideRefinements}" item-alias="navigation"> <gb-list class="gb-navigation-crumb" items="{$navigation.refinements}" item-alias="refinement" inline> <gb-refinement-crumb></gb-refinement-crumb> </gb-list> </gb-list> </div> </yield>', 'gb-breadcrumbs.gb-stylish > .gb-breadcrumbs,[data-is="gb-breadcrumbs"].gb-stylish > .gb-breadcrumbs{ display: flex; justify-content: flex-start; align-items: baseline; }', '', function(opts) {
    this._mixin(Breadcrumbs);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/breadcrumbs/gb-breadcrumbs.tag.html